import { all, fork } from 'redux-saga/effects'
import getSaga from './getSaga'
import postSaga from './postSaga'

export default function* holidaysListSaga() {
  yield all([fork(postSaga), fork(getSaga)])
}
